import _ from 'lodash';
import cz from '../translations/cz.json';
import en from '../translations/en.json';
import { getMarket } from "./getMarket";

const MARKET = getMarket();

export const __ = (word, type = '') => {
    switch (MARKET) {
        case 'cz':
            word = _.has(cz, word) ? cz[word] : word;
            break;

        case 'en':
            word = _.has(en, word) ? en[word] : word;
            break;
    }

    switch (type) {
        case 'l':
            return word.toLowerCase();

        case 'u':
            return word.toUpperCase();

        default:
            return word;
    }
};
